import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { performCRMSearchWithEmptyProperties } from '../../../CRMSearchProvider/client';
import { getRecordCount } from '../../../utils';
import { COMPANY_TYPE_ID, FILL_EMPTY_ONLY_OPTION_VAL } from '../../../../constants';
import { enqueueBulkRequestRpc } from '../../../../../__generated__/chirp/com/hubspot/custom/enrichment/rpc/client/SmartPropertiesBulkService';
import { getPropertiesRpc } from '../../../../../__generated__/chirp/com/hubspot/custom/enrichment/rpc/client/PropertyConfigService';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export async function fetchSmartProperty(context) {
  const {
    propertyName
  } = context;
  const companySmartPropertiesResponse = await rpcClient.call(getPropertiesRpc, {
    request: {
      objectType: COMPANY_TYPE_ID
    }
  });
  const smartProperty = companySmartPropertiesResponse.properties.find(property => property.propertyName === propertyName);
  return {
    propertyName: smartProperty === null || smartProperty === void 0 ? void 0 : smartProperty.propertyName,
    label: smartProperty === null || smartProperty === void 0 ? void 0 : smartProperty.propertyLabel,
    objectType: smartProperty === null || smartProperty === void 0 ? void 0 : smartProperty.objectTypeId,
    promptQuestion: smartProperty === null || smartProperty === void 0 ? void 0 : smartProperty.config.promptQuestion
  };
}
export function runSmartFill(context) {
  const {
    fillOption,
    objectTypeId,
    selectionCrmSearchQuery,
    selectionIds,
    selectionMethod,
    selectedProperties
  } = context;
  if (!objectTypeId) {
    throw new Error('objectTypeId is required for smart fill operations');
  }
  const isFillEmptyOnly = fillOption === FILL_EMPTY_ONLY_OPTION_VAL;
  const baseRequest = {
    objectTypeId,
    propertyNames: selectedProperties,
    estimatedObjectCount: getRecordCount({
      selectionMethod,
      selectionCrmSearchQuery,
      selectionIds
    }),
    fillEmptyValuesOnly: isFillEmptyOnly
  };
  let request;
  if (selectionMethod === 'BY_IDS') {
    request = Object.assign({}, baseRequest, {
      selectedObjectIds: selectionIds.map(Number)
    });
  } else {
    request = Object.assign({}, baseRequest, {
      selectedObjectIds: [],
      searchRequest: Object.assign({}, selectionCrmSearchQuery, {
        objectTypeId
      })
    });
  }
  return rpcClient.call(enqueueBulkRequestRpc, {
    request
  });
}
export async function getEmptyPropertiesCount(context) {
  const {
    propertyName,
    selectionCrmSearchQuery
  } = context;
  if (!selectionCrmSearchQuery) {
    return 0;
  }
  const result = await performCRMSearchWithEmptyProperties({
    query: selectionCrmSearchQuery
  }, [propertyName]);
  return result.total;
}